import { Injectable } from '@angular/core';
import { Beneficio } from 'src/app/models/beneficio.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { daApi, listaDaApi, MAP_BENEFICIO, ORDEM_BENEFICIO, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class BeneficioService {

  constructor(
    public api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<BeneficiosApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_BENEFICIO, 'order');

    return this.api.get('/benefit' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_BENEFICIO);
        return { beneficios: lista.itens, numeroPaginas: lista.numeroPaginas } as BeneficiosApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/benefit/${id}`).pipe(map((res: any) => daApi(res, MAP_BENEFICIO)));
  }

  post(beneficio: Beneficio): Observable<any> {
    return this.api.post('/benefit', paraApi(beneficio, MAP_BENEFICIO)).pipe(map((res: any) => daApi(res, MAP_BENEFICIO)));
  }

  patch(beneficio: Beneficio): Observable<any> {
    return this.api.patch('/benefit', paraApi(beneficio, MAP_BENEFICIO)).pipe(map((res: any) => daApi(res, MAP_BENEFICIO)));
  }

  delete(beneficio: Beneficio): Observable<any> {
    return this.api.delete(`/benefit/${beneficio.id}`);
  }

  deleteSelected(beneficios: Beneficio[]): Observable<any> {
    return this.api.deleteComCorpo('/benefit', beneficios.map(b => ({ id: b.id })));
  }

  ordenar(beneficios: Beneficio[]): Observable<any> {
    return this.api.post('/benefit/sort', beneficios.map(b => paraApi(b, MAP_BENEFICIO)));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}

export interface BeneficiosApi {
  beneficios: Beneficio[];
  numeroPaginas: number;
}
